import { render, staticRenderFns } from "./MedalForm.vue?vue&type=template&id=6a4ecf3a&scoped=true"
import script from "./MedalForm.vue?vue&type=script&lang=js"
export * from "./MedalForm.vue?vue&type=script&lang=js"
import style0 from "./MedalForm.vue?vue&type=style&index=0&id=6a4ecf3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4ecf3a",
  null
  
)

export default component.exports